import type { Leader_Board } from "~/core";

export const isLeaderBoard = (item: unknown): item is Leader_Board => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "leader_board"
  );
};
